/** Применение темы к документу. В нативной сборке — к контейнеру приложения. */
export function applyTheme(theme) {
  const root = globalThis.document?.documentElement
  if (!root) return
  if (theme === 'dark') root.setAttribute('data-theme', 'dark')
  else root.removeAttribute('data-theme')
}
